import Api from './Navigation.api';
import { UserError } from 'utilities/ErrorHandlling/ErrorHandlling';
import { NavigationConfigConstants } from './Navigation.constants';
import { map as _map, isEmpty as _isEmpty, forEach as _forEach, compact, isUndefined as _isUndefined } from 'lodash-es';
import { store } from '../../index';
const defaultActivated = ['profile', 'business-profile'];
// --- Format :: new API('API URL', 'API SERVICE NAME - from api_service.jsx')
const navigation = new Api('services/', 'account');
const locale = new Api('services/', 'locale');

const onConstructPermissionObject = list => {
  let permissionsObject = {};
  const skipMainMenuCheck = ['nav_connect'];

  if (!_isEmpty(list)) {
    const constructPermissionObject = (obj, hasChild) => {
      if (obj['path']) {
        const split = compact(obj.path?.split('/')) || [];
        let menu = '';
        if (_isEmpty(hasChild)) {
          menu = split?.[0];
        } else {
          menu = split?.[1];
        }

        if (!_isEmpty(menu)) permissionsObject[menu] = false;
      }
      if (!_isEmpty(obj?.subMenu) || !_isEmpty(obj?.menu)) {
        const g = obj?.subMenu || obj?.menu;
        for (let item of g) {
          constructPermissionObject(item, 'hasChild');
        }
      }
    };

    _forEach(list, menu => {
      if (!skipMainMenuCheck?.includes(menu?.id)) constructPermissionObject(menu, null);
    });

    if (!_isEmpty(defaultActivated)) {
      _forEach(defaultActivated, menu => (permissionsObject[menu] = true));
    }
  }

  return permissionsObject;
};

const constructMenuOrder = graasMenu => {
  const menuOrder = [];
  _forEach(graasMenu, menu => {
    if (!_isEmpty(menu?.subMenu)) {
      const subMenus = menu?.subMenu;
      _forEach(subMenus, subMenu => {
        if (!_isEmpty(subMenu?.menu)) {
          const childMenus = subMenu?.menu;
          _forEach(childMenus, childMenu => {
            menuOrder?.push(childMenu?.id);
          });
        }
      });
    } else {
      menuOrder?.push(menu?.id);
    }
  });
  return menuOrder;
};

const onConstructPermissionObjectBeta = list => {
  let permissionsObject = {};
  const skipMainMenuCheck = ['nav_connect'];

  if (!_isEmpty(list)) {
    _forEach(list, obj => {
      if (!skipMainMenuCheck?.includes(obj?.id)) {
        if (obj['path'] || obj['basePath']) {
          let path = obj['path'] || obj['basePath'];
          const split = compact(path?.split('/')) || [];
          let menu = '';
          if (_isEmpty(split?.[1])) {
            menu = split?.[0];
          } else {
            menu = split?.[1];
          }
          let isEnabled = true;
          if (!_isUndefined(obj?.isEnabled)) {
            isEnabled = obj?.isEnabled;
          }

          if (!_isEmpty(menu) && isEnabled) permissionsObject[menu] = false;
        }
      }
    });

    if (!_isEmpty(defaultActivated)) {
      _forEach(defaultActivated, menu => (permissionsObject[menu] = true));
    }
  }

  return permissionsObject;
};

// --- Add external route key if route is not related with this application
const isExternalRoute = routeObject => {
  if (_isEmpty(routeObject)) return null;

  let updatedObject = {
    ...routeObject
  };

  if (!['nav_analyze', 'nav_predict', 'nav_connect', 'nav_extract', 'nav_hoppr'].includes(updatedObject?.id)) {
    updatedObject = {
      ...updatedObject,
      isExternalRoute: true
    };
  }

  return updatedObject;
};

// --- Remove header menu when empty sub-menu
const onConstructMenuObject = menu => {
  for (let i = 0; i < menu?.length; i++) {
    const subMenu = menu[i].subMenu;
    if (subMenu && Array.isArray(subMenu)) {
      const filteredSubMenu = subMenu.filter(item => {
        if (Array.isArray(item.menu)) {
          return item.menu.length > 0;
        } else {
          return true;
        }
      });
      menu[i].subMenu = filteredSubMenu;
    }
  }
  return menu;
};

// --- Get navigation API call
export const getNavigationMenus = (allMenus, isNewMenuStructureEnabled) => {
  let apiData = {};
  return async dispatch => {
    try {
      dispatch({ type: NavigationConfigConstants.GET_NAVIGATION_REQUEST });
      apiData = await navigation.getNavigationMenus();

      if (apiData && apiData.hasError) {
        throw apiData;
      } else {
        const { data } = apiData;
        let { menu } = data;
        let availableMenus = [];
        _forEach(menu, singleMenu => {
          let isMenuEnabled = true;
          if (!_isUndefined(singleMenu?.isEnabled)) {
            isMenuEnabled = singleMenu?.isEnabled;
          }
          if (isMenuEnabled) availableMenus?.push(singleMenu?.id);
        });
        const appliedMenuPermissions = isNewMenuStructureEnabled
          ? onConstructPermissionObjectBeta(menu)
          : onConstructPermissionObject(menu);

        const updated_main_routes = {
          menu: _map(allMenus, route => isExternalRoute(route)) || [],
          userMenu: _map(menu, route => isExternalRoute(route)) || [],
          allMenus: allMenus || [],
          availableMenus: availableMenus || []
        };
        dispatch({ type: NavigationConfigConstants.GET_NAVIGATION_SUCCESS, payload: updated_main_routes });

        const state = store?.getState();
        const initialPermissionSet = { ...state?.Navigation?.permissions } || {};

        if (!_isEmpty(appliedMenuPermissions)) {
          _forEach(appliedMenuPermissions, (_value, key) => {
            if (!defaultActivated.includes(key)) {
              if (initialPermissionSet.hasOwnProperty(key)) {
                initialPermissionSet[key] = true;
              }
            }
          });
        }

        dispatch({
          type: NavigationConfigConstants.GET_NAVIGATION_PERMISSION_SUCCESS,
          payload: { ...initialPermissionSet, loading: false }
        });
      }
    } catch (error) {
      dispatch({ type: NavigationConfigConstants.GET_NAVIGATION_ERROR });
      throw new UserError(error);
    }
  };
};

// --- Get navigation API call
export const getAvailableNavigationMenus = (isNewMenuStructureEnabled = false) => {
  let apiData = {};
  return async dispatch => {
    try {
      dispatch({ type: NavigationConfigConstants.GET_AVAILABLE_NAVIGATION_REQUEST });
      apiData = await navigation.getAvailableNavigationMenus();

      if (apiData && apiData.hasError) {
        throw apiData;
      } else {
        const { data } = apiData;
        const { graasMenu } = data;

        dispatch(getNavigationMenus(graasMenu, isNewMenuStructureEnabled));
        dispatch({ type: NavigationConfigConstants.GET_AVAILABLE_NAVIGATION_SUCCESS, payload: graasMenu });

        const getO = onConstructPermissionObject(graasMenu);
        dispatch({ type: NavigationConfigConstants.GET_NAVIGATION_PERMISSION_SUCCESS, payload: getO });

        const menuOrder = constructMenuOrder(graasMenu);
        dispatch({ type: NavigationConfigConstants.GET_NAVIGATION_ORDER, payload: menuOrder });
      }
    } catch (error) {
      dispatch({ type: NavigationConfigConstants.GET_AVAILABLE_NAVIGATION_ERROR });
      throw new UserError(error);
    }
  };
};

export const getFeatureMenus = () => {
  return async dispatch => {
    try {
      dispatch({ type: NavigationConfigConstants.GET_FEATURES_REQUEST });
      let apiData = await navigation.getFeatureMenus();
      if (apiData && apiData.hasError) {
        throw apiData;
      } else {
        const { data } = apiData;
        dispatch({ type: NavigationConfigConstants.GET_FEATURES_SUCCESS, payload: data?.features || [] });
      }
    } catch (error) {
      dispatch({ type: NavigationConfigConstants.GET_FEATURES_ERROR });
      throw new UserError(error);
    }
  };
};

// --- Get submenus from selected menu
export const getNavigationSubMenus = props => {
  return async dispatch => {
    try {
      dispatch({ type: NavigationConfigConstants.GET_SUBNAVIGATION_SUCCESS, payload: props });
    } catch (error) {
      dispatch({ type: NavigationConfigConstants.GET_SUBNAVIGATION_ERROR });
      throw new UserError(error);
    }
  };
};

// --- Get navigation API call
// ----- GET statistic count
export const updateLocaleCall = async props => {
  let apiData = {};

  try {
    apiData = await locale.updateLocaleCall(props);
    if (apiData && apiData.hasError) {
      return { loading: false, error: true };
    } else {
      window.location.reload();
    }
  } catch (error) {
    return { loading: false, error: true };
  }
};
